import { useEffect, useRef, useState } from 'react';

/** Hide floating widgets on scroll down, show again on scroll up. */
export function useScrollVisibility(threshold = 10) {
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;

      if (y < 80) {
        setVisible(true);
      } else if (y - lastScrollY.current > threshold) {
        setVisible(false);
      } else if (lastScrollY.current - y > threshold) {
        setVisible(true);
      }

      lastScrollY.current = y;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return visible;
}
